import React from 'react'
import { Input, Form } from 'semantic-ui-react'

const UserInput = props => {
  return (
    <Form.Field
      control={Input}
      placeholder="Enter User ID..."
      icon="user"
      width={8}
      {...props}
    />
  )
}

export default UserInput
